import { Tag, Tooltip } from "@homebound/beam";
import { pluralize } from "src/utils";
import { OptionsTooltipContent, TooltipOption } from "./OptionsTooltipContent";

type PrerequisitesTagProps = {
  prerequisites: TooltipOption[];
  /** True when these are the `rpog.groupPrerequisites`, and not an option's own prerequisites. */
  forGroup?: boolean;
};

/** Shows a `N prerequisites` tag, with the prerequisites themselves in a tooltip. */
export function PrerequisitesTag(props: PrerequisitesTagProps) {
  const { prerequisites, forGroup = false } = props;
  if (prerequisites.isEmpty) return null;
  const count = prerequisites.length;
  return (
    <Tooltip
      data-testid="prerequisites-tooltip"
      title={<OptionsTooltipContent label={forGroup ? "Group Prerequisite" : "Prerequisite"} options={prerequisites} />}
      placement="top"
    >
      <Tag text={forGroup ? "Group Prerequisites" : `${count} ${pluralize(count, "prerequisite")}`} type="update" />
    </Tooltip>
  );
}
